var React = require('react');

function Faucet (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_52035","data-name":"Group 52035","transform":"translate(-1543 -149)"},[React.createElement("rect",{"id":"Rectangle_47493","data-name":"Rectangle 47493","width":"22","height":"22","transform":"translate(1543 149)","fill":"none","key":0}),React.createElement("path",{"id":"filter-r","d":"M4.574,7.25,8.75,14.233v4.275l6.5,2.6V14.233L19.426,7.25Zm2.852,1.5h9.148L13.75,13.767v5.125l-3.5-1.4V13.767Z","transform":"translate(1542.426 145.75)","fillRule":"evenodd","key":1})]));
}

Faucet.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Faucet;

Faucet.default = Faucet;
